import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { FirebaseProvider } from '../firebase/firebase';


@Injectable()
export class ConfigurationProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  getPagesConfig(): Observable<any> {
    return this.firebaseService.object(this.getBaseRoot() + '/' + tableNames.Configuration)
  }

  setPagesConfig(pagesConfig: any) {
    delete pagesConfig.key;

    return this.firebaseService.set(this.getBaseRoot(), tableNames.Configuration, pagesConfig)
  }


  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/configuration/configuration.ts